//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { generateComputed } from '../../common/functions/roles-computed-generator';
import Divisao from './Divisao';

export default {
  data() {
    return {
      carteiraClienteResources: this.$api.carteiraCliente(this.$resource),
      divisaoResources: this.$api.divisao(this.$resource),
      divisoes: [],
      esperar: false,
      headers: [
        { text: this.$tc('label.cod_divisao', 1), width: '10%', value: 'id_externo' },
        { text: this.$tc('label.nome', 1), value: 'nome' },
        { text: this.$tc('label.estrutura_usuario', 1), value: 'nom_estrutura_usuario' },
        { text: this.$tc('label.divisao_superior', 1), value: 'divisoes_superiores' },
        { text: this.$tc('label.diretoria', 1), value: 'is_diretoria', width: '10%', sortable: false },
      ],
      pagination: {},
      totalPage: 0,
      searchQuery: '',
      registros: [],
    };
  },
  props: {
    title: String,
    configCarteira: String,
  },
  watch: {
    pagination: {
      handler() {
        this.filtrar();
      },
      deep: true,
    },
    searchQuery() {
      this.pagination.page = 1;
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(() => {
        this.filtrar();
      }, 500);
    },
  },
  computed: {
    filteredList() {
      return [];
    },
    ...generateComputed('Divisao', [
      'canEdit',
      'canGet',
      'canAccessPage',
    ]),
    ...mapGetters('metadados', [
      'getDivisaoMetadado',
    ]),
    metadadosDivisao() {
      if (this.getDivisaoMetadado && this.getDivisaoMetadado.mapaEntidades) {
        return this.getDivisaoMetadado;
      }
      return undefined;
    },
    headersDinamico() {
      const headers = Object.assign([], this.headers);

      if (this.configCarteira === 'EXPLICITA') {
        headers.push({
          text: this.$tc('label.carteira_cliente', 1),
          value: 'carteiras_cliente',
          sortable: false,
        });
      }

      if (!this.metadadosDivisao) return headers;

      Object.keys(this.metadadosDivisao.mapaEntidades).forEach((entidade) => {
        const mapeamentoEntidade = this.metadadosDivisao.mapaEntidades[entidade];
        headers.push({
          text: mapeamentoEntidade.entidadeEstrangeira,
          value: mapeamentoEntidade.label,
          sortable: false,
        });
      });

      if (!this.somenteLeitura) {
        headers.unshift({ text: '', value: 'acoes', sortable: false, width: '1%', align: 'center' });
      }

      return headers;
    },
    somenteLeitura() {
      return !this.canEdit && this.canGet;
    },
  },
  methods: {
    buscar() {
      const params = {
        filtro: this.searchQuery,
        page: this.pagination.page,
        size: this.pagination.itemsPerPage,
        asc: !this.pagination.sortDesc[0],
        colunaOrdenacao: this.pagination.sortBy[0],
      };

      this.divisaoResources.listar(params).then((response) => {
        this.registros = response.data.resposta;
        this.montarObjetoDivisoes();
        this.totalPage = response.data.quantidadeRegistrosPagina;
        this.pararEsperar();
      }, (err) => {
        this.pararEsperar();
        this.$error(this, err);
      });
    },
    buscarCarteirasCliente(filtroComponente) {
      const filtro = Object.assign({}, filtroComponente, { size: 50, page: 0 });
      return this.carteiraClienteResources.listar(filtro);
    },
    buscarDivisoesPorEstruturaDeUsuario(divisaoSelecionada) {
      return (filtro) => {
        const params = Object.assign({}, filtro, {
          idEstruturaUsuario: divisaoSelecionada.estruturaUsuario.id,
        });
        return this.divisaoResources.pesquisasrDivisoesSuperiores(params);
      };
    },
    buscarEstruturasDeUsuario(nomeEstruturaUsuario = null) {
      const filtro = Object.assign({ }, nomeEstruturaUsuario, { size: 50, page: 0 });
      return this.estruturaUsuarioResources.listar(filtro);
    },
    filtrar() {
      if (this.esperar) return;
      this.esperar = true;
      setTimeout(() => {
        this.buscar();
      }, 5E2);
    },
    getDiretoria(divisao) {
      divisao = divisao && divisao.value ?
        JSON.parse(divisao.value) : {};
      return divisao ? divisao.diretoria : false;
    },
    montarColunasDinamicas() {
      const objeto = [];
      Object.keys(this.metadadosDivisao.mapaEntidades).forEach((entidade) => {
        objeto.push(this.metadadosDivisao.mapaEntidades[entidade].label);
      });
      return objeto;
    },
    montarObjetoDivisoes() {
      this.divisoes = this.registros.map((data) => {
        const divisao = new Divisao();
        divisao.construirAPartirDaConsultaCompleta(data);
        divisao.montarEstruturaDinamica(data, this.metadadosDivisao);
        return divisao;
      });
    },
    onEditaAreaDeAtuacao(divisao) {
      this.divisaoResources.atualizarAreaAtuacao({ id: divisao.id }
      , divisao.montarArrayComIdsDasCarteirasDeCliente());
    },
    onEditaDivisoesSuperiores(divisao) {
      this.divisaoResources.atualizarDivisoesSuperiores({
        id: divisao.id,
        idEstruturaUsuario: divisao.estruturaUsuario.id,
      }, divisao.montarArrayComIdsDasDivisoesSuperiores());
    },
    onEditarDivisao(divisao) {
      if (!divisao.desAtributos) {
        divisao.desAtributos = { diretoria: false };
      }
      this.$emit('PESQUISA_DIVISAO_EDITAR', divisao);
    },
    pararEsperar() {
      setTimeout(() => {
        this.esperar = false;
      }, 2E2);
    },
    setEstruturaUsuario(hit, row, nome) {
      this.objEstruturaUsuario.id = row.id;
      this.objEstruturaUsuario.nomEstruturaUsuario = nome;
      this.objEstruturaUsuario.estruturaUsuarioPaiId = hit.map(el => el.id);
      this.updateItemDependency(row, 'estruturaUsuarioPai', this.objEstruturaUsuario);
    },
  },
  mounted() {
    this.filtrar();
  },
};



// WEBPACK FOOTER //
// ./src/spa/divisao/DivisaoTabela.vue?vue&type=script&lang=js&